function Dd7SettingsCtrl(toaster, $scope, $state, $stateParams, $rootScope, Dd7Service, CommonService) {
  'ngInject';

  const vm = this;
  // Use $stateParams.orgId directly - inherited from parent state URL
  vm.orgId = $stateParams.orgId;
  console.log('DD7Settings init - $stateParams.orgId:', $stateParams.orgId, '$rootScope.currentOrg:', $rootScope.currentOrg);
  vm.loading = true;
  vm.saving = false;
  vm.settings = {
    enabled: false,
    auto_post: false,
    narrative: 'Amazon DD+7 Deferred Revenue Accrual',
    deferred_account_code: null,
    deferred_account_name: null,
    column_mapping: {
      product_charges: {},
      promotional_rebates: {},
      amazon_fees: {},
      other: {}
    }
  };
  vm.xeroAccounts = [];
  vm.accountsByType = {};

  vm.init = function() {
    vm.loadSettings();
    vm.loadXeroAccounts();
  };

  vm.loadSettings = function() {
    vm.loading = true;
    console.log('DD7 LOAD - orgId:', $stateParams.orgId);
    // Use $stateParams.orgId directly like working payout mapping does
    Dd7Service.getSettings($stateParams.orgId, function(response) {
      console.log('DD7 LOAD response:', response.status, response.data);
      vm.loading = false;
      if (response.status == 200 && response.data.settings) {
        // Merge with defaults to ensure structure exists
        vm.settings = angular.merge({}, vm.settings, response.data.settings);
        // Ensure column_mapping has the right structure
        if (!vm.settings.column_mapping) {
          vm.settings.column_mapping = {};
        }
        ['product_charges', 'promotional_rebates', 'amazon_fees', 'other'].forEach(function(key) {
          if (!vm.settings.column_mapping[key]) {
            vm.settings.column_mapping[key] = {};
          }
        });
      }
    });
  };

  vm.loadXeroAccounts = function() {
    // Use $stateParams.orgId directly like working payout mapping does
    CommonService.getAccounts($stateParams.orgId, function(response) {
      vm.xeroAccounts = response.data || [];
      vm.groupAccountsByType();
    });
  };

  vm.groupAccountsByType = function() {
    vm.accountsByType = {};
    vm.xeroAccounts.forEach(function(account) {
      var type = account.type || 'Other';
      if (!vm.accountsByType[type]) {
        vm.accountsByType[type] = [];
      }
      vm.accountsByType[type].push(account);
    });
  };

  vm.onAccountSelect = function(field) {
    var code = vm.settings.deferred_account_code;
    var account = vm.xeroAccounts.find(function(a) { return a.code === code; });
    if (account) {
      vm.settings.deferred_account_name = account.name;
    }
  };

  vm.onColumnMappingSelect = function(column) {
    var code = vm.settings.column_mapping[column].code;
    var account = vm.xeroAccounts.find(function(a) { return a.code === code; });
    if (account) {
      vm.settings.column_mapping[column].name = account.name;
    }
  };

  vm.save = function() {
    vm.saving = true;
    console.log('DD7 SAVE - orgId:', $stateParams.orgId, 'settings:', JSON.stringify(vm.settings));
    // Use $stateParams.orgId directly like working payout mapping does
    Dd7Service.saveSettings($stateParams.orgId, vm.settings, function(response) {
      console.log('DD7 SAVE response:', response.status, response.data);
      vm.saving = false;
      if (response.status == 200) {
        toaster.pop('success', 'Success', 'Settings saved');
        vm.loadSettings(); // Reload to get updated complete status
      } else {
        toaster.pop('error', 'Error', response.data.error || 'Failed to save');
      }
    });
  };

  vm.goBack = function() {
    // Use current stateParams to get fresh orgId from URL, not cached value
    var currentOrgId = $stateParams.orgId || $state.params.orgId;
    console.log('DD7 goBack - orgId:', currentOrgId, 'vm.orgId:', vm.orgId, '$stateParams:', $stateParams);
    $state.go('user.organization.dashboard.dd7.list', { orgId: currentOrgId }, { inherit: false });
  };

  // Initialize on load
  vm.init();
}

Dd7SettingsCtrl.$inject = ['toaster', '$scope', '$state', '$stateParams', '$rootScope', 'Dd7Service', 'CommonService'];

export default {
  name: 'Dd7SettingsCtrl',
  fn: Dd7SettingsCtrl
};
